import { AuditPage } from 'features/audit';

export const AdminAuditPage: React.FC = () => <AuditPage />;
